module.exports = __webpack_public_path__ + "static/Baquet2-b3e2b53b0ded061b95b588fbcaff88a5.jpg";